"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCollisionSheet = void 0;
const index_1 = require("../../index");
const makeCollisionSheet = () => {
    return [
        {
            '@type': 'grid',
            'key': '820c0ce9-6c6c-45b5-9186-d2762470766e',
            columns: 1,
            children: [
                {
                    '@type': 'card',
                    key: '596cf79a-d142-42e5-a1aa-4087b38e95fd',
                    title: 'Collision',
                    gridColumn: '1/2',
                    className: 'cardCntnr',
                    children: [
                        {
                            '@type': 'grid',
                            key: 'a748d0ae-a708-4bac-9014-4c68662b49d1',
                            columns: 1,
                            children: [...index_1.template.collisionSheetCollision],
                        },
                    ],
                },
                {
                    '@type': 'card',
                    key: '207c2069-bc77-47af-8e04-1c8192696389',
                    title: 'Témoin(s)',
                    gridColumn: '1/2',
                    className: 'cardCntnr',
                    children: [
                        {
                            '@type': 'grid',
                            key: '11029d00-5f91-4533-bc61-de4f6cd49735',
                            columns: 1,
                            children: [...index_1.template.collisionSheetTemoins],
                        },
                    ],
                },
                {
                    '@type': 'card',
                    key: 'f4966a55-3c06-42dc-a8ea-916a122e3505',
                    title: 'Collision avec obstable(s)',
                    gridColumn: '1/2',
                    className: 'cardCntnr',
                    children: [
                        {
                            '@type': 'grid',
                            key: '59db3026-90b5-4a0d-ac8e-288e100a0f2c',
                            columns: 1,
                            children: [...index_1.template.collisionSheetCollisionObstacles],
                        },
                    ],
                },
                {
                    '@type': 'card',
                    key: 'd84d5d4c-c82d-48c8-a001-979a2a131ead',
                    title: 'Collision avec tiers',
                    gridColumn: '1/2',
                    className: 'cardCntnr',
                    children: [
                        {
                            '@type': 'grid',
                            key: '4ba86df5-a24a-41ae-a449-d34460e6a48c',
                            columns: 1,
                            children: [...index_1.template.collisionSheetCollisionTiers],
                        },
                    ],
                },
            ],
        },
    ];
};
exports.makeCollisionSheet = makeCollisionSheet;
